import gql from 'graphql-tag'

export const setSavedSearchDashboardMutation = () => gql`
  mutation setSavedSearchDashboard($id: String, $showInDashboard: Boolean) {
    setSavedSearchDashboard(id: $id, showInDashboard: $showInDashboard) {
      savedSearch {
        id
        showInDashboard
      }
      error
    }
  }
`

export const getUserBlockerCountsDashboard = () => gql`
  query getBlockerCountsDashboard(
    $filters: [SearchFilterDashboard]
    $searchText: String
    $blockerType: String
  ) {
    getBlockerCountsDashboard(
      filters: $filters
      searchText: $searchText
      blockerType: $blockerType
    ) {
      total
      errors
    }
  }
`

export const setSavedSearchDashboardOrderMutation = () => gql`
  mutation setSavedSearchDashboardOrder($orders: [SavedSearchOrderInput!]!) {
    setSavedSearchDashboardOrder(savedSearchOrders: $orders) {
      success
      error
    }
  }
`

export const getUserSavedSearchesDashboardQuery = () => gql`
  query getUserSavedSearches($orderInput: Boolean) {
    getUserSavedSearches(orderInput: $orderInput) {
      savedSearches {
        name
        filters {
          id
          values {
            value
            displayValue
          }
        }
        id
        searchText
        favorite
        viewId
        showInDashboard
        order
      }
      error
    }
  }
`
